module.exports = __webpack_public_path__ + "assets/5faa246b5cb782633d9bfd23e8d4156c.mp3";